exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.btn-apply-condition {\n  position: relative !important;\n  width: 100%;\n  box-shadow: 0 0 0 transparent;\n  color: #fff;\n  border: 1px solid #624dd6;\n  font-size: 12px;\n  padding: 7px 10px;\n  background: #624dd6;\n  display: block;\n  border-radius: 4px;\n  margin-top: 7px;\n}\n", ""]);

// exports
